import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {HolidaysModelService} from '../../../Models/Rrhh/Holidays/holidays-model.service';
import {HolidaysTypesModelService} from '../../../Models/Rrhh/Holidays/holidays-types-model.service';

@Injectable({
  providedIn: 'root'
})
export class HolidaysApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: HolidaysModelService,
    public modelTypes: HolidaysTypesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener vacaciones
   *
   */
  public getHolidays(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getVacaciones').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los tipos de vacaciones
   *
   */
  public getHolidaysTypes(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getVacacionesTipos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.modelTypes.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir vacaciones
   *
   */
  public setHolidays(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setHolidays', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir una imagen
   *
   */
  public addHolidayImage(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAusenciaFoto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
